/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import { buildUrl } from "../../utils/bindUrl";
import {
  IOrigin,
  IResponseListOrigin,
  IResponseShowOrigin,
} from "../../interfaces/origins";
import qs from "qs";
import { api } from "../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";

const BASE = "/origins";

const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listOrigins({
  filter,
  includes,
  page,
  limit,
  select,
  sort,
}: IListParams) {
  const { data } = await api.get<IResponseListOrigin>(BASE, {
    params: { filter, includes, page, limit, select, sort },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showOrigin({
  id,
  includes,
}: {
  id: string | number;
  includes?: string[];
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowOrigin>(url, {
    params: { includes },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function createOrigin({ origin }: { origin: IOrigin }) {
  const { data } = await api.post<IResponseShowOrigin>(BASE, { origin });
  return data;
}

export async function updateOrigin({
  id,
  origin,
}: {
  id: string | number;
  origin: IOrigin;
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowOrigin>(url, { origin });
  return data;
}
